import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CustomerCaseContextService {
  private _portfolios$ = new BehaviorSubject<any[] | null>(null);
  readonly portfolios$ = this._portfolios$.asObservable();

  setPortfolios(portfolios: any[]) {
    this._portfolios$.next(portfolios);
  }
}
